export default {
  prevSlideText: {
    id: 'buying_guide_slider_prev_slide',
    defaultMessage: 'Display previous slide',
  },
  nextSlideText: {
    id: 'buying_guide_slider_next_slide',
    defaultMessage: 'Display next slide',
  },
  readMore: {
    id: 'hub_buying_guide_read_more_article',
    defaultMessage: 'Read more',
  },
}
